var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KeychainKeyTypesLC, } from '@interfaces/keychain.interface';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { getRequiredWifType } from 'src/utils/requests.utils';
export const isWhitelisted = (arr, data, domain, current_rpc) => {
    try {
        if (getRequiredWifType(data) === KeychainKeyTypesLC.active ||
            !arr ||
            !data.username ||
            current_rpc.testnet) {
            return false;
        }
        else {
            return arr[data.username][domain][data.type];
        }
    }
    catch (e) {
        return false;
    }
};
export const addToWhitelist = (username, domain, type) => __awaiter(void 0, void 0, void 0, function* () {
    const noConfirm = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.NO_CONFIRM);
    let keep = !noConfirm ? {} : noConfirm;
    if (!keep[username]) {
        keep[username] = {};
    }
    if (!keep[username][domain]) {
        keep[username][domain] = {};
    }
    keep[username][domain][type] = true;
    yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.NO_CONFIRM, keep);
});
export const removeFromWhitelist = (noConfirm, username, domain, operation) => {
    delete noConfirm[username][domain][operation];
    if (!Object.keys(noConfirm[username][domain]).length) {
        delete noConfirm[username][domain];
    }
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.NO_CONFIRM, noConfirm);
    return noConfirm;
};
